import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import React, { Component } from "react";

export class CancelIconButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onClick: props.onClick,
      caption: props.caption,
      pageId: props.pageId,
      isHovered: false,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <Button
        type={this.state.type}
        variant="contained"
        id="ptsButton"
        style={{
          marginRight: "1rem",
          background: this.state.isHovered ? "#b6bec8" : "#d3d8de",
          padding: this.state.pageId === "Message" ? "4px 12px" : "2px 10px",
        }}
        // startIcon={<CloseIcon />}
        onClick={this.onClick.bind(this)}
        onMouseEnter={() => this.setState({ isHovered: true })}
        onMouseLeave={() => this.setState({ isHovered: false })}
      >
        Cancel
      </Button>
    );
  }
}
export default CancelIconButton;
